import { Typography } from '@mui/material'

export const PageTitle: React.FC<{ children: React.ReactNode | React.ReactNode[] }> = ({ children }) => {
  return (
    <Typography variant="h3" component="h3" gutterBottom>
      {children}
    </Typography>
  )
}
